<template lang="pug">
	.app--local-db-manager
		Popup(v-if="visible", :popupVisible.sync="visible", :title="$tCaption('Cache manager')", :width="540", :autosize="true")
			.flex-col.space-large.app--local-db-manager
				.flex-row.justify
					.flex-row
					.flex-row
						DxCheckBox(:text="$tCaption('Cache enabled')", :value.sync="creativeBlobsDbCacheEnabled.value")
				.flex-col.space.cached-metric(v-for="item in info")
					b {{item.text}}
					.flex-row.space-large
						.flex-col
							.font-small.grey {{$tCaption('Size')}}
							.font-big.text-end {{getDisplaySize(item.statistics.totalBytes)}}
						.flex-col.text-end
							.font-small.grey {{$tCaption('Blobs count')}}
							.font-big.text-end {{item.statistics.blobsCount}}
						.flex-col(v-if="item.statistics.maxDate")
							.font-small.grey {{$tCaption('Last updated')}}
							.font-big {{$moment(item.statistics.maxDate).format('LLL')}}
					.flex-row(v-if="item.statistics.totalBytes")
						DxButton(:text="$tCaption('Clear cache')", @click="clearCache(item)", icon="fas fa-times")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Close', '@actions')", @click="visible = false")
</template>

<script>
	import Popup from 'app-core/Popup.vue';
	import DxButton from 'devextreme-vue/button';
	import storage from 'storage';
	import DxCheckBox from 'devextreme-vue/check-box';

	export default {
		name: 'app--local-db-manager',
		props: ['metrics'],
		components: { Popup, DxButton, DxCheckBox },
		data() {
			return {
				visible: false,
				info: [],
				creativeBlobsDbCacheEnabled: storage.prop('creativeBlobsDb_cacheEnabled', void 0, true)
			};
		},
		watch: {
			'creativeBlobsDbCacheEnabled.value'(v) {
				this.$creativeBlobsDb.cacheEnabled = v;
			}
		},
		methods: {
			getDisplaySize(bytes) {
				return `${Math.round(bytes / 1024 / 1024 * 10) / 10} MB`;
			},
			show() {
				if (__DEBUG__)
					window.cacheManager = this;
				this.visible = false;
				this.calcInfo();
				setImmediate(() => this.visible = true);
			},
			async calcInfo() {
				this.info = [];

				if (this.metrics.length)
					await Promise.all(this.metrics.map(async m => {
						const metricData = await this.$creativeBlobsDb.search(m.condition);
						this.info.push({
							text: m.name,
							statistics: this.$creativeBlobsDb.getStatistics(metricData),
							keys: metricData.map(f => f.id)
						});
					}));

				const all = await this.$creativeBlobsDb.all();
				this.info.push({
					text: this.$tCaption('Total cached'),
					statistics: this.$creativeBlobsDb.getStatistics(all),
					keys: all.map(f => f.id)
				});
			},
			clearCache(item) {
				this.$confirm(this.$tCaption('Confirm action', '@actions'), this.$tCaption('Are you sure you want to clear current cache? This will slow down applicaiton.')).then(r => {
					this.$creativeBlobsDb.delete(item.keys);
					setTimeout(this.calcInfo, 500);
				});
			}
		}
	}
</script>

<style lang="scss">
	.app--local-db-manager {
		.cached-metric {
			padding: 20px;
			background: #f2f2f2;
			border-radius: 4px;
		}
	}
</style>